export function normalizeAccents(str) {
  if (!str || typeof str !== "string") return str;
  try {
    // Try to repair some malformed UTF-8 sequences, then strip diacritics.
    const decoded = decodeURIComponent(escape(str));
    return decoded.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  } catch {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
}

export function normalizeGeoJsonProperties(geojson) {
  if (!geojson || geojson.type !== "FeatureCollection" || !Array.isArray(geojson.features)) return geojson;
  return {
    ...geojson,
    features: geojson.features.map((feature) => {
      const newProperties = {};
      if (feature?.properties && typeof feature.properties === "object") {
        for (const [key, value] of Object.entries(feature.properties)) {
          newProperties[key] = typeof value === "string" ? normalizeAccents(value) : value;
        }
      }
      return { ...feature, properties: newProperties };
    }),
  };
}

